import {
  ArrayMinSize,
  IsArray,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateIf,
} from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { CleaningFrequency, isPeriodicCleaningFrequency } from './cleaning-frequency.enum';
import { DayOfWeek } from './day-of-week.enum';

export class UpdateCleaningAreaDto {
  @IsString()
  @IsNotEmpty()
  @IsOptional()
  name?: string;

  @IsString()
  @IsNotEmpty()
  @IsOptional()
  icon?: string;

  // null clears the field: the backend ignores undefined keys on PUT.
  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  description?: string | null;

  @IsEnum(CleaningFrequency)
  @IsOptional()
  frequency?: CleaningFrequency;

  // Ignored for periodic areas (the backend clears it). Whether the resulting
  // weekly area still has at least one day is checked by the service, which
  // knows the stored frequency.
  @ValidateIf(
    (dto: UpdateCleaningAreaDto) =>
      !isPeriodicCleaningFrequency(dto.frequency) && dto.scheduledDays !== undefined,
  )
  @IsArray()
  @ArrayMinSize(1)
  @IsEnum(DayOfWeek, { each: true })
  scheduledDays?: DayOfWeek[];

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  products?: string | null;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  procedure?: string | null;
}
